import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

const ShippingQuoteFilter = () => import('./screens/index.vue')

const shippingRoutes = [];

export const SHIPPING_QUOTE_REQUEST_PATH = '/propostas-frete/solicitacoes';
export const SHIPPING_QUOTE_ANALISYS_PATH = '/propostas-frete/analises';

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.REQUEST_QUOTE_SHIPPING
  ])
) {
  shippingRoutes.push({
    path: SHIPPING_QUOTE_REQUEST_PATH,
    name: 'Cadastro / Consulta|Proposta de Frete - Solicitação',
    component: ShippingQuoteFilter,
    meta: {
      requiresAuth: true,
      title: 'Solicitação de Proposta de Frete',
      analise: false
    },
  });
}
if (
  checkUserPermissions([
    PERMISSIONS_KEYS.ANALISE_QUOTE_SHIPPING,
    PERMISSIONS_KEYS.ANALISE_QUOTE_SHIPPING_VIEW,
  ])
) {
  shippingRoutes.push({
    path: SHIPPING_QUOTE_ANALISYS_PATH,
    name: 'Cadastro / Consulta|Proposta de Frete - Análise',
    component: ShippingQuoteFilter,
    meta: {
      requiresAuth: true,
      title: 'Analise de Proposta de Frete',
      analise: true
    },
  });
}

export { shippingRoutes };

